exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formBox[data-v-3e4318ea]{margin:auto;min-width:3.125rem;max-width:5.20833rem}.formBox[data-v-3e4318ea] .el-date-editor,.formBox[data-v-3e4318ea] .el-select{width:100%}.u-row[data-v-3e4318ea]{display:flex;align-content:center;gap:0.10417rem}.u-row .el-form-item[data-v-3e4318ea]{flex:1}\n", ""]);

// exports
